import React, { useEffect, useState } from "react";
import SideBar from "./SideBar";
import { dateConvert } from "../dateConverter";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import axiosClient from "../axios";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import loaderimg from "../assets/images/loader.gif";
import Pagination_2 from "./Pagination_2";
import CSVDownload from "./CSVDownload";

const UploadCsvUserStat = () => {
  const [loader, setLoader] = useState(false);
  const [bulkData, setBulkData] = useState([]);
  const [bulkDataReq, setBulkDataReq] = useState([]);
  const [date, setDate] = useState({
    start: null,
    end: null,
  });
  const [userStatData, setUserStatData] = useState();

  const [pagination, setPagination] = useState({
    page: 0,
    limit: 100,
  });
  // csv data table pagination start
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 100; // Adjust this value as needed
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = bulkData.slice(indexOfFirstItem, indexOfLastItem);
  // csv data table pagination end

  const readFileAsText = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target.result);
      reader.onerror = reject;
      reader.readAsText(file);
    });
  };

  const handleBulkCsv = async (event) => {
    setLoader(true);
    try {
      // setDataUpdated(false);
      const file = event.target.files[0];
      if (!file) return;

      const text = await readFileAsText(file); // Await file reading

      // Expected headers
      const expectedHeaders = ["emailId", "phoneNumber", "userId"];
      const fileHeaders = text
        .split("\n")[0]
        .split(",")
        .map((header) => header.trim());
      // Validate headers
      if (
        !expectedHeaders.every((header, index) => header === fileHeaders[index])
      ) {
        alert("Invalid CSV Format: Headers should be 'emailId, phoneNumber'");
        return;
      }
      const rows = text.split("\n").slice(1); // Remove header

      const formattedData = rows
        .map((row) => row.split(",")) // Split by comma
        .filter((cols) => cols.length >= 2) // Ensure valid rows
        .map(([emailId, phoneNumber, userId]) => ({
          emailId,
          phoneNumber, userId
        }));
      if (formattedData.length === 0) {
        alert("Invalid CSV Format");
        return;
      }
      setBulkData(formattedData);
      setBulkDataReq(formattedData);
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoader(false);
    }
  };

  const handleDate = (e, f) => {
    const res = dateConvert(e);
    if (f === 1) {
      setDate({ ...date, start: e });
      return;
    }
    if (f === 2) {
      setDate({ ...date, end: e });
      return;
    }
  };

  const handleDownloadCsv = (data, name) => {
    try {
      const dataToExport = data.map((val, key) => ({
        "Email Id": val?.emailId,
        "Phone Number": val?.phoneNumber,
        "totalAmount": val?.totalAmount,
        "totalRevenueAmount": val?.totalRevenueAmount,
        "userId": val?.userId,
        "wallet": val?.wallet ? val?.wallet : 0,
      }));
      CSVDownload(dataToExport, name);
    } catch (error) {
      console.error("Error downloading CSV:", error);
    }
  };

  const handleUserStat = async (isCsvDownload = false) => {
    if (!date.start || !date.end) {
      alert("Please Select Start Date And End Date");
      return;
    }

    if (bulkDataReq?.length === 0) {
      alert("Please Upload Csv File");
      return;
    }

    let userData = {
      s_date: dateConvert(date.start),
      e_date: dateConvert(date.end),
      bulkData: bulkDataReq,
      page: pagination?.page,
      limit: pagination?.limit,
      isCsvDownload: isCsvDownload,
    };

    setLoader(true);
    await axiosClient
      .post("/user-uploaded-csv-stat", userData)
      .then((res) => {
        if (isCsvDownload) {
          handleDownloadCsv(res.data.response, "matchUser.csv");
        } else {
          setBulkData([]);
          setUserStatData(res.data.response);
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log("res-", err.response.data.messae);
        alert(err.response.data.messae);
      })
      .finally(() => setLoader(false));
  };

  useEffect(() => {
    if (userStatData?.length > 0) {
      handleUserStat();
    }
  }, [pagination?.page, pagination?.limit]);

  return (
    <>
      <SideBar handleSideBar={true} activeTab={"UserCsvDataStat"} />
      <div className="screen">
        <div className="dFlex">
          <h2 className="screenHeading catHead">User Csv Data Stat</h2>
        </div>

        <div className="upload-user-csv-flex">
          <div className="user-upload">
            <form>
              <input
                type={"file"}
                id="bulkdepositCsv"
                onChange={handleBulkCsv}
                accept={".csv"}
                style={{ display: "none" }}
              />
              <label htmlFor="bulkdepositCsv" className="userCsvButton">
                Upload Csv
              </label>
            </form>
          </div>

          {/* <div className="user-upload"> */}
          <button
            style={{
              padding: "10px 20px",
              width: "fit-content",
              fontSize: "15px",
              fontWeight: "700",
              color: "#fff",
              backgroundColor: "#2b579a",
              borderRadius: "6px",
            }}
            onClick={() => handleUserStat(true)}
          >
            Download Csv
          </button>
          {/* </div> */}

          <div className="addPartnerButton">
            <div className="dFlex alignCenter  ">
              <div className="dFlex w70">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Start Date"
                    value={date.start}
                    onChange={(value) => handleDate(value, 1)}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </div>
            </div>
            <div className="dFlex alignCenter  ">
              <div className="dFlex w70">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="End Date"
                    value={date.end}
                    onChange={(value) => handleDate(value, 2)}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </div>
            </div>

            {
              <button
                className="tSubnitButton"
                onClick={() => handleUserStat()}
              >
                FetchUserStat
              </button>
            }
          </div>
        </div>

        <div className="profileInfoBox table">
          {!loader ? (
            <>
              <div style={{ width: "100%" }} className="container app-body">
                {userStatData?.length > 0 && (
                  <>
                    <div className="tabel-scrol">
                      <table id="users">
                        <thead>
                          <tr>
                            <th>S.NO.</th>
                            <th>name</th>
                            <th>Email Id </th>
                            <th>Phone Number</th>
                            <th style={{ width: "130px" }}>Total Amount</th>
                            <th style={{ width: "130px" }}>Total Revenue Amount</th>
                            <th style={{ width: "130px" }}>User Id</th>
                            <th style={{ width: "130px" }}>Wallet</th>
                          </tr>
                        </thead>
                        <tbody>
                          {userStatData?.map((val, key) => (
                            <tr key={key}>
                              <td>{pagination?.limit * pagination?.page + (key + 1)}</td>
                              <td
                                className="clickabuetd"
                                onClick={() =>
                                  window.open(
                                    `/users/transaction/${val.userId}`
                                  )
                                }
                              >
                                {val?.name}
                              </td>
                              <td>{val?.emailId}</td>
                              <td>{val?.phoneNumber}</td>
                              <td>{val?.totalAmount}</td>
                              <td>{val?.totalRevenueAmount}</td>
                              <td>{val?.userId}</td>
                              <td>{val?.wallet ? val?.wallet : "0"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </div>
            </>
          ) : (
            <>
              <div className="loaderImage">
                <img src={loaderimg} alt="loader" />
              </div>
            </>
          )}
        </div>

        {userStatData?.length > 0 && (
          <div>
            <Pagination_2
              filterDataInput={pagination}
              setFilterDataInput={setPagination}
            />
          </div>
        )}

        {/* // csv data table */}
        {!userStatData?.length > 0 && (
          <div className="profileInfoBox table">
            <>
              <div style={{ width: "100%" }} className="container app-body">
                {bulkData.length > 0 && (
                  <div
                    style={{ width: "100%" }}
                    className="container app-body bulkTable"
                  >
                    <div className="tabel-scrol">
                      <table id="users">
                        <thead>
                          <tr>
                            <th style={{ width: "40px" }}>S.NO.</th>
                            <th style={{ width: "75px" }}>User Email</th>
                            <th style={{ width: "130px" }}>Number</th>
                            <th style={{ width: "130px" }}>User ID</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems.map((val, index) => (
                            <tr key={index}>
                              <td>{indexOfFirstItem + index + 1}</td>
                              <td className="clickable">{val?.emailId}</td>
                              <td>{val?.phoneNumber}</td>
                              <td>{val?.userId}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div className="uploadCsv-pagination">
                      <button
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                        disabled={currentPage === 1}
                      >
                        Previous
                      </button>
                      <button
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(
                              prev + 1,
                              Math.ceil(bulkData.length / itemsPerPage)
                            )
                          )
                        }
                        disabled={
                          currentPage ===
                          Math.ceil(bulkData.length / itemsPerPage)
                        }
                      >
                        Next
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </>
          </div>
        )}
      </div>
    </>
  );
};

export default UploadCsvUserStat;
